import React, { useCallback } from 'react';
import { Button } from 'src/components/Button/Button';
import { Size } from 'src/components/ProductDetail/ProductSizes';

import classes from './CallForStockAvailability.scss';

type Props = {
    size: Size;
    notify: (size: Size) => void;
};

export const CallForStockAvailability: React.FC<Props> = ({ notify, size }) => {
    const onNotify = useCallback(() => {
        notify && notify(size);
    }, [notify, size]);

    return (
        <div>
            <small className={classes.sizesStock}>Call for Stock Availability</small>
            <Button variant="reset" className={classes.notify} onClick={onNotify}>
                Notify me when it's in stock
            </Button>
        </div>
    );
};
